import classNames from "classnames";
import styles from "./option-button.module.scss";

interface OptionButtonInterface {
  children: string;
  onClick?: () => void;
  isDisabled?: boolean;
  isActive: boolean;
}

const OptionButton = ({
  children,
  isDisabled,
  onClick,
  isActive
}: OptionButtonInterface) => {
  return (
    <button
      className={classNames(styles["option-button"], {
        [styles["option-button--active"]]: isActive
      })}
      onClick={onClick}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
};

export default OptionButton;
